import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcWasteClassification = DatabaseCode;

const nonExemptNonHazardous: RrcWasteClassification = {
  code: "NON_EXEMPT_NON_HAZARDOUS",
  displayValue: {
    id: "common.entity.rrcwasteclassification.nonexemptnonhazardous",
    defaultMessage: "Non-Exempt Non-Hazardous",
  },
};

const exemptNonHazardous: RrcWasteClassification = {
  code: "EXEMPT_NON_HAZARDOUS",
  displayValue: {
    id: "common.entity.rrcwasteclassification.exemptnonhazardous",
    defaultMessage: "Exempt Non-Hazardous",
  },
};

export const rrcWasteClassification = {
  nonExemptNonHazardous,
  exemptNonHazardous,
};

export const rrcWasteClassifications: RrcWasteClassification[] = Object.values(rrcWasteClassification);

export const toRrcWasteClassification = (code: string): RrcWasteClassification =>
  toDatabaseCode(code, rrcWasteClassifications);

export const toRrcWasteClassificationSafely = (
  code: string | undefined,
  defaultValue: RrcWasteClassification | undefined = undefined
): RrcWasteClassification | undefined => toDatabaseCodeSafely(code, rrcWasteClassifications, defaultValue);
